exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".attribute-container[data-v-c05a2c0e] {\n  display: grid;\n  gap: 15px 15px;\n  grid-template-columns: 4fr 4fr 4fr 1fr;\n}\n.grid-right[data-v-c05a2c0e] {\n  grid-column-end: -1;\n  justify-self: end;\n  align-self: end;\n}\n", ""]);

